import React from 'react';
import './WelcomeComponent.scss';
import DashBoard from '../../containers/dashboard/Dashboard';

const WelcomeComponent = () => (
    <div 
    className="container welcome-container"
    >
        {/* <div className="content">
            <h1>LOI</h1>
            <h3>Make it Easy</h3>
            <DashBoard/>
        </div> */}
        <DashBoard/>
    </div>
);

export default WelcomeComponent;
